import Dropdown from './components/Dropdown';
import DropdownItem from './components/DropdownItem';
import DropdownStatic from './components/DropdownStatic';
import DropdownTemplate from './components/DropdownTemplate';

const _Dropdown = Object.assign(Dropdown, {
  Item: DropdownItem,
  Static: DropdownStatic,
  Template: DropdownTemplate,
});

export default _Dropdown;
